export default __webpack_public_path__ + "static/media/bod.e75cfdd5.png";